// extracted by mini-css-extract-plugin
module.exports = {"recommendContents":"styles_recommendContents__6KV6F"};